export default __webpack_public_path__ + "media/images/images_v2/submit-left-462d5749ea9a550a86e8812644233e3a.png";